import { ReactElement } from "react";

interface ReportSuccessProps {
  /**
   * Only set when a workbook actually came back and was saved. When the
   * endpoint answers with JSON instead, there is no download to point at and
   * the copy must not claim one.
   */
  fileName?: string;
}

/** Shown once the report has been processed. */
const ReportSuccess: React.FC<ReportSuccessProps> = ({
  fileName,
}): ReactElement => (
  <div className="success-panel">
    <span className="icon">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m5 12.5 4.5 4.5L19 7.5" />
      </svg>
    </span>
    <h4>Client IPs filled</h4>
    {fileName ? (
      <p>
        Your completed report has been downloaded as{" "}
        <span className="file">{fileName}</span>.
      </p>
    ) : (
      <p>
        The report was processed successfully. No file was returned in the
        response — check with the backend team if you expected a download.
      </p>
    )}
  </div>
);

export default ReportSuccess;
